import {Counter} from "store/dashboard/DashboardStore"

type props = {
    label: string
    counter: Counter
    onClick?: () => void
}
export default function DeviceStatusSummaryCard({label, counter, onClick}: props) {
    return (
        <div className="column is-one-third is-clickable" onClick={onClick}>
            <div className="box-operation">
                <div className="columns">
                    <div className="column is-one-quarter pt20">
                        <h5 className="title is-size-3 has-text-white  ml20 ">{label}</h5>
                    </div>
                    <div className="column columns is-multiline">
                        <StatusCounter label="전체" count={counter.ttlCount} styleType="primary"/>
                        <StatusCounter label="정상" count={counter.normalCount} styleType="info"/>
                        <StatusCounter label="미운행" count={counter.noneOperationCount} styleType="grey"/>
                        <StatusCounter label="점검" count={counter.errorCount} styleType="warning"/>
                        <StatusCounter label="긴급" count={counter.emergencyCount} styleType="danger" isLast={true}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

type styleType = "primary" | "info" | "success" | "warning" | "danger" | "light" | "dark" | "grey"
const StatusCounter = ({label, count, styleType, isLast = false}: { label: string, count: number, styleType: styleType, isLast?: boolean }) => {
    return (
        <div className={`column ${!isLast && 'box-line-right2'} pd20`}>
            <span className={`tag ${styleType}-2`}>{label}</span>
            <div className={`mt5 is-size-3 has-text-${styleType}`}>{count.toLocaleString()}</div>
        </div>
    )
}

